module.exports = __webpack_public_path__ + "static/media/qiwi.862eb288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/qiwi.svg
// module id = 550
// module chunks = 0